export default __webpack_public_path__ + "static/media/search-green.98529631.svg";